import script from "./DocPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocPage.vue?vue&type=script&setup=true&lang=ts"

import "./DocPage.vue?vue&type=style&index=0&id=104ef829&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104ef829"]])

export default __exports__